<template>
  <div class="ly_mainInner">

    <!-- 問題表示画面 -->
    <div class="" v-if="scene === 'question'" id="question">
      <div class="bl_headingBlock">
        <div class="bl_txtBlock">
          <p>
            <!-- eslint-disable-next-line -->
            {{ grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby> ステージ {{ stage }}
          </p>
        </div>
        <ul class="bl_meterBlock">
          <li v-for="n in 5" :key="n" :class="setMeterBg(n)"></li>
        </ul>
      </div>
      <div class="bl_quizBlock">
        <div class="bl_questionBlock">
          <div class="bl_questionBlock_img">
            <img src="/kids/quiz/static/image/question_img_03.png" alt="">
          </div>
          <p class="bl_questionBlock_txt" v-html="question.question"></p>
        </div>

        <div class="bl_choiceBtnBlock">
          <ul :class="isImage()">
            <li v-for="(answer, index) in question.answers" :key="index" class="bl_choiceBtn">
              <input v-model="choice" type="radio" :id="index" :value="index">
              <label :for="index" :class="checkedLabel(choice, index)">
                <div v-if="answer.pcImage !== ''" class="bl_choiceBtn_img">
                  <img class="pcBlock" :src="answer.pcImage" alt="">
                  <img class="spBlock" :src="answer.spImage" alt="">
                </div>
                <p class="bl_choiceBtn_txt" v-html="answer.choice"></p>
              </label>
            </li>
          </ul>
          <div class="bl_choiceBtn_txt__sp spBlock" v-if="question.answers[0].pcImage[0]">
            <!-- eslint-disable-next-line -->
            <p v-for="(answer, index) in question.answers" :key="index" v-html="answer.choice"></p>
          </div>
        </div>
      </div>
      <div class="bl_btnBlock">
        <!-- eslint-disable-next-line -->
        <a class="el_btn" href="#" @click="checkAnswer"><ruby>答<rp>(</rp><rt>こた</rt><rp>)</rp></ruby>え<ruby>合<rp>(</rp><rt>あ</rt><rp>)</rp></ruby>わせ</a>
      </div>
    </div>

    <!-- 不正解画面 -->
    <div v-if="scene === 'incorrect'">
      <div class="bl_answerBlock">
        <div class="bl_answerBlock_img incorrect">
          <img src="/kids/quiz/static/image/question_img_01.png" alt="">
        </div>
        <!-- eslint-disable-next-line -->
        <p class="bl_answerBlock_txt">もう<ruby>一度<rp>(</rp><rt>いちど</rt><rp>)</rp></ruby>やってみよう</p>
      </div>
      <div class="bl_btnBlock">
        <a class="el_btn" href="#" @click="retry">やりなおす</a>
      </div>
    </div>


    <!-- 正解画面 -->
    <div class="" v-if="scene === 'correct'">
      <div class="bl_answerBlock">
        <div class="bl_answerBlock_img correct">
          <img src="/kids/quiz/static/image/question_img_02.png" alt="">
        </div>
        <!-- eslint-disable-next-line -->
        <p class="bl_answerBlock_txt"><ruby>次<rp>(</rp><rt>つぎ</rt><rp>)</rp></ruby>の<ruby>問題<rp>(</rp><rt>もんだい</rt><rp>)</rp></ruby>にチャレンジしよう</p>
      </div>
      <div class="bl_btnBlock">
        <a class="el_btn" href="#" @click="nextQuestion">つぎへ</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Question',
  data() {
    return {
      questionShow: true,
      scene: 'question',
      choice: '',
      grade: 5,
      stage: 1,
      questionCount: 1,
      backgroundColor: {
        hp_bgColor_1: false,
        hp_bgColor_2: false,
        hp_bgColor_3: false,
        hp_bgColor_4: false,
        hp_bgColor_5: false,
      },
    };
  },
  created() {
    // 自動保存データがある場合
    if (this.selectLevel.grade > 0 && this.selectLevel.stage > 0) {
      this.grade = this.selectLevel.grade;
      this.stage = this.selectLevel.stage;
      if (this.selectLevel.questionCount !== 6) {
        this.questionCount = this.selectLevel.questionCount;
      }
    }
    // 級に合わせて背景色をセット
    this.$set(this.backgroundColor, `hp_bgColor_${this.grade}`, true);
    // 現在の級を保存
    this.saveLoadData(this.grade, this.stage, this.questionCount);
  },
  computed: {
    // すべての問題文を取得
    ...mapState('quizJSON', [
      'questionData',
    ]),
    ...mapMutations('odakyuQuizQuestionNumArr', [
      'setQuestionNum',
    ]),
    ...mapState('odakyuQuizQuestionNumArr', [
      'questionNumArr',
    ]),
    // ステージ選択画面から選択した級などを取得
    ...mapState('selectLevel', [
      'selectLevel',
    ]),
    // クリアしたデータを取得
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
    // 選択された級・ステージデータをも元に問題文を取得
    question() {
      return this.questionData.grade[this.grade - 1].questions[this.questionNumArr[this.grade - 1][this.stage - 1][this.questionCount - 1]]; /* eslint-disable-line max-len */
    },
  },
  methods: {
    // ページ遷移
    changeCurrentPage(page) {
      this.$store.commit('currentPage/changeCurrentPage', page);
    },
    // 何問目かを判定して背景色をつける
    setMeterBg(n) {
      if (n <= this.questionCount) {
        return this.backgroundColor;
      }
      return false;
    },
    // checkeされたらlabelの背景色を変更
    checkedLabel(checked, index) {
      if (checked === index) {
        return this.backgroundColor;
      }
      return false;
    },
    // 問題に画像が含まれているか
    isImage() {
      if (this.question.answers[0].pcImage[0]) {
        return {
          bl_choiceBtnBlock_flex: true,
        };
      }
      return {
        bl_choiceBtnBlock_flex: false,
      };
    },
    // 回答チェック
    checkAnswer() {
      if (this.choice >= 0 && this.choice <= 2 && this.choice !== '') {
        if (this.question.correct === this.choice + 1) {
          this.questionCount += 1;
          if (this.questionCount !== 6) {
            this.saveLoadData(this.grade, this.stage, this.questionCount);
          } else {
            this.saveLoadData(0, 0, 1);
          }
          this.scene = 'correct';
        } else {
          this.scene = 'incorrect';
        }
      }
      return false;
    },
    // 回答状況の自動保存
    saveLoadData(grade, stage, questionCount) {
      const saveData = {
        grade,
        stage,
        questionCount,
      };
      this.$store.commit('odakyuQuizLoadData/saveLoadData', saveData);
    },
    // 不正解時に同じ問題に戻る
    retry() {
      this.scene = 'question';
      this.choice = '';
    },
    // 全問正解時にクリアデータの上書きとクリア画面への遷移
    nextQuestion() {
      if (this.questionCount === 6) {
        if (this.clearData.grade !== 0) {
          if (this.grade < this.clearData.grade) {
            this.$store.commit('odakyuQuizClearData/changeGrade', this.grade);
            this.$store.commit('odakyuQuizClearData/changeStage', this.stage);
          } else if (this.grade === this.clearData.grade) {
            if (this.stage > this.clearData.stage) {
              this.$store.commit('odakyuQuizClearData/changeStage', this.stage);
            }
          }
        } else {
          this.$store.commit('odakyuQuizClearData/changeGrade', this.grade);
          this.$store.commit('odakyuQuizClearData/changeStage', this.stage);
        }
        this.changeCurrentPage('result');
      } else {
        this.retry();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ly_mainInner{

  ruby{
    > rt{
      font-size: 10px;
    }
  }

  li{
    input[type=radio] {
      display: none;
    }
  }

  #question{
    width: 100%;

    .bl_headingBlock{
      margin-bottom: 32px;

      .bl_txtBlock{
        font-size: 34px;
        font-weight: bold;
        text-align: center;
        line-height: 57.6px;
        color: #000;
        margin-bottom: 60px;
      }

      .bl_meterBlock{
        box-sizing: border-box;
        display: flex;
        justify-content: center;

        > li {
          width: 113px;
          height: 20px;
          border: 2px solid #000;
          border-right: 2px dotted #000;
          border-left: none;

          &:first-of-type{
            border-left: 2px solid #000;
            border-radius: 10px 0 0 10px;
          }

          &:last-of-type{
            border-right: 2px solid #000;
            border-radius: 0 10px 10px 0;
          }
        }
      }
    }

    .bl_quizBlock{
      max-width: 832px;
      margin: 0 auto 40px;

      .bl_questionBlock{
        display: flex;
        margin-bottom: 29px;

        .bl_questionBlock_img{
          width: 73px;
          min-width: 73px;
          margin-right: 12px;
        }

        .bl_questionBlock_txt{
          width: 90%;
          margin-top: 16px;
        }
      }

      .bl_choiceBtnBlock{
        .bl_choiceBtn{
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-bottom: 10px;
            position: relative;
            color: #000;
            font-size: 24px;
            font-weight: bold;

            &:last-of-type{
              margin-bottom: 0;
            }

          > label{
            align-self: stretch;
            width: 100%;
            padding: 20px 0;
            background-color: #fff;
            border-radius: 10px;
            cursor: pointer;

            .bl_choiceBtn_txt{
              text-align: center;
              font-size: 20px;
              font-weight: bold;
            }
          }
        }

        .bl_choiceBtnBlock_flex{
          display: flex;
          justify-content: space-between;

          .bl_choiceBtn{
            max-width: 257px;
            margin-bottom: 0;
            margin-right: 10px;

            &:last-of-type{
              margin-right: 0;
            }

            > label{
              padding-top: 0;
            }
          }
        }
      }
    }
  }
  .bl_answerBlock{
    .bl_answerBlock_img{
      margin: 0 auto 73px;

      &.incorrect{
        max-width: 235px;
      }

      &.correct{
        max-width: 424px;
      }
    }

    .bl_answerBlock_txt{
      margin-bottom: 38px;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      line-height: 24px;
    }
  }

  .bl_btnBlock{
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .el_btn{
      max-width: 324.7px;

      &:last-of-type{
        margin-left: 0;
      }
    }
  }
}

@media screen and (max-width: 768px){
  .ly_mainInner{

    #question{
      .bl_headingBlock{
        margin-bottom: 14px;

        .bl_txtBlock{
          font-size: 26px;
          margin-bottom: 16px;
        }

        .bl_meterBlock{
          > li{
            width: 68px;
          }
        }
      }

      .bl_quizBlock{
        margin-bottom: 20px;

        .bl_questionBlock{
          margin-bottom: 16px;

          .bl_questionBlock_img{
            width: 38px;
            min-width: 38px;
          }

          .bl_questionBlock_txt{
            margin-top: 0 !important;
            font-size: 15px;
          }
        }

        .bl_choiceBtnBlock{
          .bl_choiceBtn{
            font-size: 14px;
            flex-direction: column;

            > label{
              .bl_choiceBtn_txt{
                display: block;
              }
            }

            .bl_choiceBtn_txt{
              display: none;
            }
          }

          .bl_choiceBtnBlock_flex{
            .bl_choiceBtn{
              > label{
                padding-bottom: 0;

                .bl_choiceBtn_txt{
                  display: none;
                }
              }

              .bl_choiceBtn_txt{
                display: flex;
                margin-top: 15px;
              }
            }
          }

          .bl_choiceBtn_txt__sp{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            text-align: center;
            word-break: break-all;
            font-size: 14px;
            font-weight: bold;

            > p{
              width: calc(100% / 3);
              margin-right: 10px;

              &:last-of-type{
                margin-right: 0;
              }
            }
          }
        }
      }
    }
    .bl_answerBlock{
      .bl_answerBlock_txt{
        font-size: 18px;
      }
    }
  }
}

@media all and (-ms-high-contrast:none){
  .ly_mainInner{
    #question{
      .bl_quizBlock{
        .bl_questionBlock{
          .bl_questionBlock_txt{
            margin-top: 14px;
          }
        }

        .bl_choiceBtnBlock{
          .bl_choiceBtn{
            > label{
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue